import { app } from '../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user', {
        url: '',
        redirectTo: window.env.userLandingPage,
        resolve: {account},
        views: {
            '': 'user',
            'header@user': 'userHeader',
        },
    });
}

/** @ngInject */
function account(Account) {
    return Account.get();
}



// WEBPACK FOOTER //
// ./src/portal/states/user/user.state.js